import e from "../../utils/classNames.js";
import { normalizeIconName as t } from "../../utils/iconNames.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItemListItem.tsx
var i = (i) => {
	let { hasLink: a, iconName: o, icon: s, onClick: c, className: l, children: u, ...d } = i, f = o ?? s, p = e("ActionBarItemListItem", a && "has-link", l), m = e("ActionBarItemListItemIcon", "uikit-icon", f && t(f)), h = e("ActionBarItemListItemButton");
	return /* @__PURE__ */ r("li", {
		...d,
		className: p,
		onClick: c,
		children: [
			f && /* @__PURE__ */ n("span", { className: m }),
			a && !c && /* @__PURE__ */ n("span", { children: u }),
			c && /* @__PURE__ */ n("div", {
				className: h,
				children: u
			}),
			!a && !c && u
		]
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=ActionBarItemListItem.js.map